"use client";

import {
  Button,
  NavLink,
  ThemeIcon,
  useComputedColorScheme,
} from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import PlayCircleOutlineRounded from "@mui/icons-material/PlayCircleOutlineRounded";
import OnboardingVideoModal from "./modals/OnboardingVideoModal";
import classes from "./WatchDemoButton.module.css";

export default function WatchDemoButton({
  isNavLink,
}: {
  isNavLink?: boolean;
}) {
  const [opened, { open, close }] = useDisclosure(false);
  const colorScheme = useComputedColorScheme("light");

  return (
    <>
      <OnboardingVideoModal opened={opened} onClose={close} />
      {isNavLink ? (
        <NavLink
          label="Watch Demo"
          onClick={open}
          leftSection={
            <ThemeIcon
              variant="outline"
              radius="md"
              size={20}
              color="gray"
              className={`${classes.themeIcon} side-nav-icon`}
            >
              <PlayCircleOutlineRounded style={{ width: 20, height: 20 }} />
            </ThemeIcon>
          }
          classNames={{
            root: classes.navLinkRoot,
            label: classes.navLinkLabel,
          }}
          className="side-nav-label"
        />
      ) : (
        <Button
          variant="filled"
          color={colorScheme === "dark" ? "lightblue.3" : "gold"}
          size="md"
          onClick={open}
          leftSection={<PlayCircleOutlineRounded />}
          className={classes.cta}
          c={colorScheme === "dark" ? "darkblue.7" : "darkblue.9"}
        >
          Watch Demo
        </Button>
      )}
    </>
  );
}
